import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import _ from 'lodash';
import { default as ChevronRight } from 'wix-ui-icons-common/ChevronRight';
import _Symbol from '../symbol/symbol';
import contextMenuPositionUtil from '../../util/contextMenuPosition';
import { getRectByBoundingRect, getRectByReactElement } from '../../util/rect';
import compose from '../../hoc/compose';
import Text from '../text/text';
import DropDownBase from '../dropDownBase/dropDownBase';
import PropTypes from 'prop-types';

var ContextMenuFolder = /*#__PURE__*/function (_React$Component) {
  _inherits(ContextMenuFolder, _React$Component);

  var _super = _createSuper(ContextMenuFolder);

  function ContextMenuFolder(props) {
    var _this;

    _classCallCheck(this, ContextMenuFolder);

    _this = _super.call(this, props);
    _this.key = Math.random();
    _this.state = {
      isOpen: false,
      optionsStyle: {}
    };

    _this.isOpen = function () {
      if (_this.props.disabled) {
        return false;
      }

      if (_this.props.hasActiveInside) {
        return true;
      }

      return _.isUndefined(_this.props.isOpen) ? _this.state.isOpen : _this.props.isOpen;
    };

    _this.getAlignment = function () {
      var _contextMenuPositionU = contextMenuPositionUtil.CONSTS.ALIGNMENT,
          TOP = _contextMenuPositionU.TOP,
          BOTTOM = _contextMenuPositionU.BOTTOM,
          RIGHT = _contextMenuPositionU.RIGHT;
      var unsupported = [TOP, BOTTOM];

      var isSupported = function isSupported(alignment) {
        return alignment && !unsupported.includes(alignment);
      };

      var _this$props = _this.props,
          alignment = _this$props.alignment,
          menuAlignment = _this$props.menuAlignment;

      if (isSupported(alignment)) {
        return alignment;
      }

      if (isSupported(menuAlignment)) {
        return menuAlignment;
      }

      return RIGHT;
    };

    _this.getDirection = function () {
      return _this.props.direction || _this.props.menuDirection || contextMenuPositionUtil.CONSTS.DIRECTION.BOTTOM;
    };

    _this.onOptionsLayoutChange = function (optionsBoundingRect) {
      if (optionsBoundingRect) {
        var viewport = contextMenuPositionUtil.getViewportSize();
        var buttonRect = getRectByReactElement(_assertThisInitialized(_this));
        var optionsRect = getRectByBoundingRect(optionsBoundingRect);
        var params = {
          alignment: _this.getAlignment(),
          direction: _this.getDirection(),
          hOverflow: props.hOverflow,
          vOverflow: props.vOverflow
        };
        var optionsPosition = contextMenuPositionUtil.getOptionsPosition(viewport, buttonRect, optionsRect, params);
        _this.lastValidOptionsX = _.isNaN(optionsPosition.x) ? _this.lastValidOptionsX : optionsPosition.x;

        _this.setState({
          optionsStyle: {
            top: optionsPosition.y,
            left: _this.lastValidOptionsX,
            height: optionsPosition.height,
            width: optionsPosition.width
          }
        });
      }
    };

    _this.toggleOptions = function (isOpen) {
      var newState = _.isUndefined(isOpen) ? !_this.isOpen() : isOpen;

      if (newState !== _this.state.isOpen) {
        _this.setState({
          isOpen: newState
        });
      }
    };

    return _this;
  }

  _createClass(ContextMenuFolder, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var wasActive = prevProps.active || prevProps.hasActiveInside;
      var isActive = this.props.active || this.props.hasActiveInside;

      if (wasActive && !isActive) {
        this.toggleOptions(false);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          active = _this$props2.active,
          disabled = _this$props2.disabled,
          icon = _this$props2.icon,
          label = _this$props2.label,
          hasActiveInside = _this$props2.hasActiveInside,
          getClassName = _this$props2.getClassName,
          translateIfNeeded = _this$props2.translateIfNeeded,
          onMouseEnter = _this$props2.onMouseEnter,
          onMouseLeave = _this$props2.onMouseLeave,
          onOptionsMouseLeave = _this$props2.onOptionsMouseLeave;
      var selected = /*#__PURE__*/React.createElement("div", {
        key: this.key,
        className: getClassName('context-menu-action ') + (active || hasActiveInside ? ' active ' : '') + (disabled ? ' disabled' : ''),
        onMouseEnter: disabled ? null : onMouseEnter,
        onMouseLeave: disabled ? null : onMouseLeave
      }, icon ? /*#__PURE__*/React.createElement(_Symbol, {
        className: "symbol-folderIcon"
      }, icon) : null, /*#__PURE__*/React.createElement("span", {
        className: "context-menu-folder-label"
      }, /*#__PURE__*/React.createElement(Text, {
        skin: "secondary",
        size: "small",
        weight: "thin"
      }, translateIfNeeded(label))), /*#__PURE__*/React.createElement(_Symbol, {
        className: "symbol-folderArrow"
      }, /*#__PURE__*/React.createElement(ChevronRight, {
        size: "18px"
      })));
      return /*#__PURE__*/React.createElement(DropDownBase, {
        automationId: this.props.automationId,
        dataHook: this.props.dataHook,
        className: this.props.getClassName('control-context-menu-folder'),
        disabled: disabled,
        displayArrow: false,
        selected: selected,
        optionsStyle: this.state.optionsStyle,
        onLayoutChange: this.onOptionsLayoutChange,
        optionsContainerClassName: "context-menu-options context-menu-folder-options",
        customToggle: this.toggleOptions,
        customCloseKeys: [],
        isOpen: this.isOpen(),
        blockClickOutside: false,
        options: this.props.children,
        onOptionsMouseLeave: onOptionsMouseLeave,
        keepOptionsWidth: true,
        allowInnerScroll: true,
        openOnHover: true
      });
    }
  }]);

  return ContextMenuFolder;
}(React.Component);

ContextMenuFolder.displayName = 'ContextMenuFolder';
ContextMenuFolder.propTypes = {
  disabled: PropTypes.bool,

  /** Folder prefix icon */
  icon: PropTypes.node,

  /** Folder label */
  label: PropTypes.string,
  alignment: PropTypes.string,
  direction: PropTypes.string,

  /** For how many pixels folder's dropdown should overlap with folder acion item horizontally */
  hOverflow: PropTypes.number,

  /** For how many pixels folder's dropdown should overlap with folder acion item vertically */
  vOverflow: PropTypes.number,
  isOpen: PropTypes.bool
};
ContextMenuFolder.defaultProps = {
  disabled: false,
  hOverflow: 12,
  vOverflow: 4
};
export default compose(ContextMenuFolder);